import React from "react";
const  DocumentPreview = ({ fileUrl, fileName }) => {
    return (
      <div>
        <p>File: {fileName}</p>
        <div className="df-bt1">
        <a
          href={fileUrl}
          target="_blank" 
          rel="noopener noreferrer" 
          download={fileName}
          style={{
            textDecoration: "none",
            color: "#007bff",
            cursor: "pointer",
          }}
        >
          Download File
        </a>
        </div>
      </div>
    );
  };
  
  export default DocumentPreview;



// import React from "react";

// const DocumentPreview = ({ fileUrl, fileName }) => {
//   if (!fileUrl) return <p>No document available for preview.</p>;

//   const getFileType = (url) => {
//     const extension = url.split(".").pop().toLowerCase();
//     return extension;
//   };

//   const fileType = getFileType(fileUrl);

//   return (
//     <div>
//       <p><strong>File:</strong> {fileName}</p>

//       <div
//         style={{
//           border: "1px solid #ccc",
//           padding: "10px",
//           minHeight: "100px",
//           maxHeight: "400px",
//           overflow: "auto",
//         }}
//       >
//         {["png", "jpg", "jpeg", "gif", "bmp", "webp"].includes(fileType) ? (
//           <img
//             src={fileUrl}
//             alt={fileName}
//             style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }}
//           />
//         ) : ["pdf"].includes(fileType) ? (
//           <p>
//             <a
//               href={fileUrl}
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ color: "#007bff", textDecoration: "none" }}
//             >
//               Open PDF in new tab
//             </a>
//           </p>
//         ) : 
//         ["txt", "csv", "log"].includes(fileType) ? (
//           <iframe
//             src={fileUrl}
//             title={fileName}
//             style={{ width: "100%", height: "300px", border: "none" }}
//           />
//         ) : (
//           <p>Preview not available for this file type. Please download it.</p>
//         )}
//       </div>

//       <div className="df-bt1" style={{ marginTop: "10px" }}>
//         <a
//           href={fileUrl}
//           target="_blank"
//           rel="noopener noreferrer"
//           download={fileName}
//           style={{
//             textDecoration: "none",
//             color: "#007bff",
//             cursor: "pointer",
//           }}
//         >
//           Download File
//         </a>
//       </div>
//     </div>
//   );
// };

// export default DocumentPreview;

